/* global intlTelInputUtils */
/* global hcaptcha */
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/js/utils'
import 'intl-tel-input/build/css/intlTelInput.css'

const phoneFormComponent = {
  isValid: false,
  captchaVerified: false,
  phone: null,
  phoneInput: null,

  init () {
    sessionStorage.clear()

    const { input } = this.$refs

    this.phoneInput = intlTelInput(input, {
      initialCountry: 'sa',
      separateDialCode: true,
      autoPlaceholder: 'aggressive',
      nationalMode: false,
      onlyCountries: input.dataset.countries.split(',')
    })
  },

  onSubmit (event) {
    if (!this.isValid || !this.captchaVerified) {
      event.preventDefault()
    }
  },

  onInput () {
    this.phone = this.phoneInput.getNumber(intlTelInputUtils.numberFormat.E164)
    this.isValid = this.phoneInput.isValidNumber()

    if (this.isValid) {
      const countryCode = this.phoneInput.getSelectedCountryData().iso2
      sessionStorage.setItem('selectedCountry', countryCode)
    }

    if (typeof this.phone === 'string') {
      this.phoneInput.setNumber(this.phone)
    }
  }
}

export default () => phoneFormComponent
window.onCaptchaLoad = function () {
  const captchaContainer = document.getElementById('captcha-container')
  const sitekey = captchaContainer.getAttribute('data-sitekey')
  const hcaptchaElement = captchaContainer.querySelector('.h-captcha')

  hcaptcha.render(hcaptchaElement, {
    sitekey,
    callback: 'PhoneFormOnCaptchaVerified',
    'expired-callback': 'PhoneFormOnCaptchaExpired'
  })

  const spinner = document.getElementById('spinner')
  if (spinner) {
    spinner.style.display = 'none'
  }
}

window.PhoneFormOnCaptchaVerified = function (token) {
  phoneFormComponent.captchaVerified = true
}

window.PhoneFormOnCaptchaExpired = function () {
  phoneFormComponent.captchaVerified = false
}
